import React from 'react';
import BaseValidator from 'services/validations/base-validator';

class MinExposureValidator extends BaseValidator {
    private errorMessage: string = 'Your total MIN EXP for teams exceeds the 100% limit.';
    protected runValidation(): void {
        // @ts-ignore
        const {stacking} = this.dependencies;

        if (!stacking.isThereCheckedCombination()) {
            return;
        }

        const firstStackMinExpValue = stacking.getTotalMinExposureOfCheckedActiveTeamsInStackNumber(1);

        if (firstStackMinExpValue > 100) {
            this.addError(this.errorMessage);
            return;
        }

        const secondStackMinExpValue = stacking.getTotalMinExposureOfCheckedActiveTeamsInStackNumber(2);

        if (secondStackMinExpValue > 100) {
            this.addError(this.errorMessage);
        }

        const thirdStackMinExpValue = stacking.getTotalMinExposureOfCheckedActiveTeamsInStackNumber(3);

        if (thirdStackMinExpValue > 100) {
            this.addError(this.errorMessage);
        }
    }
}

export default MinExposureValidator;
